export const language_not_available = {
  en: "english version not available",
  fr: "version française non disponible",
  de: "deutsche Version nicht verfügbar",
};

export function formatDate(lang, date, weekday) {
  const publish_date = new Date(date);
  const options = {
    year: "numeric",
    month: "long",
    day: "numeric",
  };
  return publish_date.toLocaleDateString(lang, options);
}

export function formatDateTime(lang, date) {
  let return_string;
  const publish_date = new Date(date);
  return_string =
    publish_date.toLocaleDateString(lang, {
      year: "numeric",
      month: "long",
      day: "numeric",
      weekday: "long",
    }) +
    ", " +
    publish_date.toLocaleTimeString(lang, {
      hour: "2-digit",
      minute: "2-digit",
    });
  return return_string;
}



// WEBPACK FOOTER //
// ./src/helpers/helpers.jsx